import { render } from "./bidangPerekonomian.vue?vue&type=template&id=65f6a9c2"
import script from "./bidangPerekonomian.vue?vue&type=script&lang=js"
export * from "./bidangPerekonomian.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__